export default {
  allDay: 'Celý deň',
};
